import { createContext, useContext } from 'react'

export interface ProfileCardBand {
  id: string
  name: string
  /** The band's owner, shown as "Owner" on their card */
  ownerId?: string
}

export interface ProfileCardContextValue {
  /** The entity the viewer has open: someone in its presence room is "Here now" */
  entityId?: string
  /** The band the open entity belongs to: cards show each person's parts in it */
  band?: ProfileCardBand
}

/** Where the viewer is, for the profile cards opened from avatars. Outside an entity, cards show identity only. */
export const ProfileCardContext = createContext<ProfileCardContextValue>({})

export const useProfileCardContext = () => useContext(ProfileCardContext)
